import { createAction } from 'redux-actions';
import * as ActionTypes from '../actionTypes/controllers';

export const getControllerList = createAction(ActionTypes.GET_CONTROLLER_LIST);
export const addController = createAction(ActionTypes.ADD_CONTROLLER);
